import { PricingDetails } from "@db-models/pricing-db.model";

export const DASHBOARD_PRICING_JSON: PricingDetails[] = [
  {
    chf: {
      monthly: { original_price: 29.90 },
      yearly: {
        // 12 * 29.90 * 0.9 = 322.92 → 323 / 12 = 26.91
        original_price: 26.91,
        saving_amount: 35.88, // 358.80 - 322.92
        saving_percent: 10
      },
    },
    eur: {
      monthly: { original_price: 29.90 },
      yearly: {
        // 12 * 29.90 * 0.9 = 322.92 → 323 / 12 = 26.91
        original_price: 26.91,
        saving_amount: 35.88, // 358.80 - 322.92
        saving_percent: 10
      },
    },
    usd: {
      monthly: { original_price: 35.00 },
      yearly: {
        // 12 * 35.00 * 0.9 = 378.00 → 378 / 12 = 31.50
        original_price: 31.50,
        saving_amount: 42.00, // 420.00 - 378.00
        saving_percent: 10
      },
    },
    gbp: {
      monthly: { original_price: 26.00 },
      yearly: {
        // 12 * 26.00 * 0.9 = 280.80 → 281 / 12 = 23.40
        original_price: 23.40,
        saving_amount: 31.20, // 312.00 - 280.80
        saving_percent: 10
      },
    },
    description: "Calenso basic",
    id: 103,
    included_bookings: 0,
    name: "basic",
    min_workers: 1,
    min_store: 1,
    min_group_appointment: 1,
    min_conference: 0,
    subscription_title: 'Basic',
    subscription_subtitle: {
      en_US: "The perfect starting point for GDPR-compalint online appointment scheduling.",
      de_CH: "Der perfekte Ausgangspunkt für die DSGVO-konforme Online-Terminplanung."
    },
    feature_list_title: {
      en_US: "Basis for scheduling your team",
      de_CH: "Basis für die Terminvereinbarung"
    },
    feature_list: {
      dashboard: [
        {
          en_US: "1 user",
          de_CH: "1 Benutzer"
        },
        {
          en_US: "1 store",
          de_CH: "1 Filiale"
        },
        {
          en_US: "GDPR, nDSG & EU-DPF compliant",
          de_CH: "DSGVO, nDSG & EU-DPF konform"
        },
        {
          en_US: "ISO 27001 certified company and servers",
          de_CH: "ISO 27001 zertifizierte Firma und Server"
        },
        {
          en_US: "BSI-certified firewall",
          de_CH: "BSI-zertifizierte Firewall"
        },
        {
          en_US: "Individual appointment scheduling",
          de_CH: "Einzelterminbuchung"
        },
        {
          en_US: "Round Robin",
          de_CH: "Round Robin"
        },
        {
          en_US: "Individual forms",
          de_CH: "Individuelle Formulare"
        },
        {
          en_US: "Website integration",
          de_CH: "Webseiten Integration"
        },
        {
          en_US: "Appointment reminders",
          de_CH: "Terminerinnerungen"
        },
        {
          en_US: "Video consultation via Zoom",
          de_CH: "Video Beratung via Zoom"
        },
        {
          en_US: "Self-service support",
          de_CH: "Self-Service-Support"
        },
      ]
    },
  },
  {
    chf: {
      monthly: { original_price: 89.90 },
      // 12 * 89.90 * 0.9 = 970.92 → / 12 = 80.91
      yearly: {
        original_price: 80.91,
        saving_amount: 107.88, // 1078.80 - 970.92
        saving_percent: 10
      }
    },
    eur: {
      monthly: { original_price: 89.90 },
      // 12 * 89.90 * 0.9 = 970.92 → / 12 = 80.91
      yearly: {
        original_price: 80.91,
        saving_amount: 107.88,
        saving_percent: 10
      }
    },
    usd: {
      monthly: { original_price: 105.00 },
      // 12 * 105 * 0.9 = 1134 → / 12 = 94.50
      yearly: {
        original_price: 94.50,
        saving_amount: 126.00, // 1260 - 1134
        saving_percent: 10
      }
    },
    gbp: {
      monthly: { original_price: 79.00 },
      // 12 * 79 * 0.9 = 853.20 → / 12 = 71.10
      yearly: {
        original_price: 71.10,
        saving_amount: 94.80, // 948 - 853.20
        saving_percent: 10
      }
    },
    description: "Calenso professional",
    id: 102,
    included_bookings: 0,
    name: "professional",
    min_workers: 3,
    min_store: 3,
    min_group_appointment: 10,
    min_conference: 0,
    subscription_title: 'Professional',
    subscription_subtitle: {
      en_US: "Ideal for businesses seeking personalized branding and dependable data protection.",
      de_CH: "Ideal für Unternehmen, die personalisierte Markenbildung und zuverlässigen Datenschutz suchen."
    },
    feature_list_title: {
      en_US: "Everything in Basic, plus",
      de_CH: "Alles in Basic, plus"
    },
    feature_list: {
      dashboard: [
        {
          en_US: "3 users",
          de_CH: "3 Benutzer"
        },
        {
          en_US: "3 stores",
          de_CH: "3 Filialen"
        },
        {
          en_US: "10 group appointments",
          de_CH: "10 Gruppentermine"
        },
        {
          en_US: "Custom logo",
          de_CH: "Benutzerdefiniertes Logo"
        },
        {
          en_US: "Video Meetings",
          de_CH: "Video Beratung"
        },
        {
          en_US: "Branches & team structure",
          de_CH: "Filialen & Team-Struktur"
        },
        {
          en_US: "Analyzes and statistics",
          de_CH: "Analysen und Statistiken"
        },
        {
          en_US: "Video consultation via GoTo Meeting, Cisco Webex",
          de_CH: "Video Beratung via GoTo-Meeting, Cisco Webex"
        },
        {
          en_US: '1 Webhook Endpoint',
          de_CH: '1 Webhook-Endpunkt'
        },
        {
          en_US: "Standard Support via email (approx. 72h)",
          de_CH: "Standard Support via E-Mail (ca. 72 Std.)"
        },
      ]
    },
  },
  {
    chf: {
      monthly: { original_price: 249.90 },
      yearly: {
        // 12 * 249.90 * 0.9 = 2698.92 → 2699 / 12 = 224.91
        original_price: 224.91,
        saving_amount: 299.88, // 2998.80 - 2698.92
        saving_percent: 10
      }
    },
    eur: {
      monthly: { original_price: 249.90 },
      yearly: {
        original_price: 224.91,
        saving_amount: 299.88,
        saving_percent: 10
      }
    },
    usd: {
      monthly: { original_price: 295.00 },
      yearly: {
        // 12 * 295 * 0.9 = 3186 → 3186 / 12 = 265.50
        original_price: 265.50,
        saving_amount: 354.00, // 3540 - 3186
        saving_percent: 10
      }
    },
    gbp: {
      monthly: { original_price: 219.00 },
      yearly: {
        // 12 * 219 * 0.9 = 2365.20 → 2365 / 12 = 197.10
        original_price: 197.10,
        saving_amount: 262.80, // 2628 - 2365.20
        saving_percent: 10
      }
    },
    description: "Calenso Business",
    id: 104,
    included_bookings: 0,
    name: "business",
    min_workers: 5,
    min_store: 5,
    min_group_appointment: 15,
    min_conference: 5,
    subscription_title: 'Business',
    subscription_subtitle: {
      en_US: "Tailored for companies aiming to digitize their appointment processes with a focus on reliable data protection and unique branding.",
      de_CH: "Zugeschnitten für Unternehmen, die ihre Terminprozesse digitalisieren möchten, mit Schwerpunkt auf zuverlässigem Datenschutz und einzigartigem Branding."
    },
    feature_list_title: {
      en_US: "Everything in Professional, plus",
      de_CH: "Alles in Professional, plus"
    },
    feature_list: {
      dashboard: [
        {
          en_US: "5 users",
          de_CH: "5 Benutzer"
        },
        {
          en_US: "5 stores",
          de_CH: "5 Filialen"
        },
        {
          en_US: "5 conference appointments",
          de_CH: "5 Konferenztermine"
        },
        {
          en_US: "15 group appointments",
          de_CH: "15 Gruppentermine"
        },
        {
          en_US: "Multilingualism",
          de_CH: "Mehrsprachigkeit"
        },
        {
          en_US: "Individual design & branding",
          de_CH: "Individuelles Design & Branding"
        },
        {
          en_US: "Qualification questions (routing)",
          de_CH: "Qualifizierungsfragen (Routing)"
        },
        {
          en_US: "Workflows",
          de_CH: "Workflows"
        },
        {
          en_US: "Encrypted customer and appointment data",
          de_CH: "Verschlüsselte Kunden- und Termindaten"
        },
        {
          en_US: 'Mail sending from your own SMTP mail server',
          de_CH: 'Mailversand von eigenem SMTP-Mailserver'
        },
        {
          en_US: '5 Webhook Endpoints',
          de_CH: '5 Webhook-Endpunkte'
        },
        {
          en_US: "Appointment confirmation & reminder via email and SMS",
          de_CH: "Terminbestätigung & -erinnerung per E-Mail & SMS"
        },
        {
          en_US: "Video consultation via Microsoft Teams",
          de_CH: "Video Beratung via Microsoft Teams"
        },
        {
          en_US: "Priority email support with callback service (approx. 24h)",
          de_CH: "Priorisierter Support via E-Mail mit Rückrufservice (ca. 24 Std.)"
        }
      ]
    }
  },
  {
    chf: {
      yearly: { original_price: 0 },
      monthly: { original_price: 0 }
    },
    eur: {
      yearly: { original_price: 0 },
      monthly: { original_price: 0 }
    },
    gbp: {
      yearly: { original_price: 0 },
      monthly: { original_price: 0 }
    },
    usd: {
      yearly: { original_price: 0 },
      monthly: { original_price: 0 }
    },
    description: "Calenso Enterprise",
    id: 105,
    included_bookings: 0,
    name: "enterprise",
    min_workers: 25,
    min_store: 10,
    min_group_appointment: 30,
    min_conference: 10,
    price_on_request: true,
    subscription_title: 'Enterprise',
    subscription_subtitle: {
      en_US: "Suited for companies requiring secure, scalable, and customizable software solutions for digitizing their appointment processes.",
      de_CH: "Geeignet für Unternehmen, die sichere, skalierbare und anpassbare Softwarelösungen für die Digitalisierung ihrer Terminprozesse benötigen."
    },
    feature_list_title: {
      en_US: "Everything in Business, plus",
      de_CH: "Alles in Business, plus"
    },
    feature_list: {
      dashboard: [
        {
          en_US: "25 users",
          de_CH: "25 Benutzer"
        },
        {
          en_US: "10 stores",
          de_CH: "10 Filialen"
        },
        {
          en_US: "10 conference appointments",
          de_CH: "10 Konferenztermine"
        },
        {
          en_US: "30 group appointments",
          de_CH: "30 Gruppentermine"
        },
        {
          en_US: "Corporate design & customization",
          de_CH: "Corporate Design & Branding"
        },
        {
          en_US: "Personal contact person (prioritized support according to SLA)",
          de_CH: "Persönlicher Ansprechspartner (priorisierter Support nach SLA)"
        },
        {
          en_US: "Company-specific user roles Advanced security settings",
          de_CH: "Erweiterte Sicherheitseinstellungen"
        },
        {
          en_US: "Audit Logs",
          de_CH: "Audit Logs"
        },
        {
          en_US: "Custom roles and permissions",
          de_CH: "Benutzerdefinierte Rollen und Berechtigungen"
        },
        {
          en_US: "Single-Sign-on (SSO)",
          de_CH: "Single-Sign-on (SSO)"
        },
        {
          en_US: "CRM and ERP integrations",
          de_CH: "CRM- und ERP Integrationen"
        },
        {
          en_US: "Dynamic Availabilities (via Office365 or Microsoft Exchange Calendar)",
          de_CH: "Dynamische Verfügbarkeiten (via Office365 oder Microsoft Exchange Kalender)"
        },
        {
          en_US: "Video consultation via Unblu",
          de_CH: "Video Beratung via Unblu"
        },
        {
          en_US: "Automatic employee onboarding and offboarding with Microsoft Entra ID",
          de_CH: "Automatisches Mitarbeiter On- & Offboarding mit Microsoft Entra ID"
        },
      ]
    },
  }
]

export const MAX_LIMITE = 100000;
export const MIN_LIMITE = 1;
export const MIN_CONFERENCE_LIMITE = 0;

export const EXTRA_USER_COST = 5;
export const EXTRA_GROUP_APPOINTMENT_COST = 10;
export const EXTRA_STORE_COST = 10;
export const EXTRA_CONFERENCE_COST = 10;

export const SALES_TOKEN = '82e80dc8-9318-4be5-9be1-e8ef79859fca';
